module.exports = __webpack_public_path__ + "static/media/icon-envelopes.68c878b0.svg";